












import { Component, Vue, Prop } from "vue-property-decorator";
import { JobItem } from "../common/interfaces";
import Store from "@/store/store";
import moment from "moment";
import axios from "axios";
import UpcomingJob from "../components/JobSearches/UpcomingJob.vue";

@Component({
  components: {
    UpcomingJob
  }
})
export default class TodaysJobs extends Vue {
  protected todaysJobs: JobItem[] = [];
  protected loadingJobs: boolean = false;

  public created() {
    this.getTodaysJobs();
    this.$root.$on("refreshJobList", this.getTodaysJobs);
  }

  public createDateFilter(field: string) {
    const startofDay = moment().startOf("day");
    const endofDay = moment()
      .startOf("day")
      .add(1, "days");
    return `${field} ge ${startofDay.toISOString()} and ${field} lt ${endofDay.toISOString()}`;
  }

  protected async getTodaysJobs() {
    this.loadingJobs = true;
    this.todaysJobs = [];
    const response = await axios.get(
      `${Store.state.Environment.ODataBaseUrl}/Problems/?$select=ProblemId,Description,Type1Id,StatusId,StatusFlag` +
        `&$expand=ProblemXtra($select=EngineerCode,BookedInDateTime,ExamDueDate),` +
        `Contact($select=ContactId;$expand=Division($select=Name;$expand=` +
        `Company($select=Name)),Address($select=AddressLine4,Postcode)),` +
        `Inventory($select=InventoryId;$expand=InventoryXtra($select=NextVisitDate)` +
        `,Division($select=DivisionId,Name;$expand=Address($select=AddressId,Postcode)` +
        `,Company($select=CompanyId,Name)))` +
        `,Type1($select=Description)` +
        `&$filter=StatusId eq 'ENGINR' and StatusFlag eq 'A' and ProblemXtra/EngineerCode eq '${
          Store.state.User.UserCode
        }' and ${this.createDateFilter("ProblemXtra/BookedInDateTime")}`,
      {
        headers: {
          Authorization: "Bearer " + Store.state.User.AccessToken
        }
      }
    );

    if (response.status === 200 && response.data) {
      const jobs = response.data.value;
      jobs.forEach((j: any) => {
        const job: JobItem = {
          JobId: j.ProblemId,
          JobDescription: j.Description,
          JobType: j.Type1Id,
          TypeDescription: j.Type1.Description,
          StatusId: j.StatusId,
          StatusFlag: j.StatusFlag,
          EngineerCode: j.ProblemXtra.EngineerCode,
          DueDate: moment(j.ProblemXtra.ExamDueDate),
          BookedInDateTime: j.ProblemXtra.BookedInDateTime
            ? moment(j.ProblemXtra.BookedInDateTime)
            : undefined,
          DivisionName: j.Inventory ? j.Inventory.Division.Name : null,
          CompanyName: j.Inventory ? j.Inventory.Division.Company.Name : null,
          AddressPostcode: j.Inventory ? j.Inventory.Division.Address.Postcode : null,
          NextVisitDate: moment(j.Inventory.InventoryXtra.BookedInDateTime)
        };

        this.todaysJobs.push(job);
      });
      this.loadingJobs = false;
    }
  }
}
